import React, { Component } from 'react';
import _ from 'lodash';

import ParkeonParkinglocationTable from '../components/ParkeonParkinglocationTable';
import ParkeonParkinglocationForm from '../components/ParkeonParkinglocationForm';

import ParkeonParkinglocationModel from '../components/ParkeonParkinglocationModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class ParkeonParkinglocationsScreen extends Component {

  state = {    
    dataLoading: true,
    dataAll: [],
    data: [],              
    parkinglocationFormModalVisible: false,    
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(force = false) {
    this.setState({
      dataLoading: true
    });
    ParkeonParkinglocationModel.getAll(force)
      .then(data => {        
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });   
      })
      .catch(err => {
        message.warning('Lokality se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,          
        });
      });
  }

  onSearch(searchText) {        
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['ParkingLocationName'].startsWith(searchText); })
    })
  }

  render() {
    return (      
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Parkeon - Seznam lokalit</h2>
          <div style={{marginBottom: '20px'}}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Název lokality"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{textAlign: 'right'}}>
                <Button type="default" onClick={() => { this.loadData(true) }} style={{marginRight: 10}}><Icon type="sync" /></Button>                
                {UserModel.isInRoles(['ADMIN', 'PARKEON_PARKINGLOCATIONS_WRITE']) 
                  ? <Button type="default" onClick={() => { this.setState({parkinglocationFormModalVisible: true}) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>          
          </div>
          <ParkeonParkinglocationForm 
            type="modal" 
            modalVisible={this.state.parkinglocationFormModalVisible} 
            onModalCancel={()=>{this.setState({ parkinglocationFormModalVisible: false })}}
            onSuccess={(form, values) => { 
              ParkeonParkinglocationModel.create(values)
                .then(() => {
                  form.resetFields(); 
                  this.loadData(true);
                });                            
            }} />
          <ParkeonParkinglocationTable
            data={this.state.data} 
            loading={this.state.dataLoading}            
            onRemoveRow={(id)=>{
              ParkeonParkinglocationModel.remove(id)
                .then(() => {
                  this.loadData(true);
                });                                          
            }}/>
        </div>
      </Layout.Content>
    );
  }
}

export default ParkeonParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/ParkeonParkinglocationsScreen.js